module.exports = __webpack_public_path__ + "static/img/XugarHero_criticalLow.4d6bd4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/brand/xugarhero/assets/xugarHero/XugarHero_criticalLow.svg
// module id = WRK3
// module chunks = 1